<template>
    <restaurant-detail
        class="restaurant-facilities"
        title="facilities"
    >
        <b-row
            tag="ul"
            v-test:facilitiesList
        >
            <b-col
                v-for="facility in facilities"
                :key="facility"
                cols="6"
                tag="li"
                v-test:facilityItem
            >
                {{ facility }}
            </b-col>
        </b-row>
    </restaurant-detail>
</template>

<script>
    import RestaurantDetail from '../../molecules/RestaurantDetail/RestaurantDetail';

    export default {
        name: 'restaurant-facilities',

        components: { RestaurantDetail },

        props: {
            facilities: {
                type: Array,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    ul {
        list-style: none;
        padding: 0;
        margin-bottom: 0;
    }
</style>
